import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-597e6e16"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper__home" }
const _hoisted_2 = {
  key: 2,
  class: "wrapper__cards"
}

import CharactersListCard from '@/components/Characters/CharactersListCard.vue';
import CharactersListSearch from '@/components/Characters/Filters/CharactersListSearch.vue';
import CharactersListFilter from '@/components/Characters/Filters/CharactersListFilter.vue';
import BaseSpinner from '@/components/UI/BaseSpinner.vue';
import NotFound from '@/views/NotFound.vue';
import CharactersListPagination from '@/components/Characters/CharactersListPagination.vue';
import { computed } from 'vue';
import { useStore } from 'vuex';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
store.dispatch('fetchCharacters');
const characters = computed(() => store.state.charactersModule.characters);
const loading = computed(() => store.state.charactersModule.isLoading);
const error = computed(() => store.state.charactersModule.error);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("main", _hoisted_1, [
      _createVNode(CharactersListSearch),
      _createVNode(CharactersListFilter),
      (_unref(error))
        ? (_openBlock(), _createBlock(NotFound, { key: 0 }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(error)), 1)
            ]),
            _: 1
          }))
        : (!_unref(characters).length && _unref(loading) && !_unref(error))
          ? (_openBlock(), _createBlock(BaseSpinner, { key: 1 }))
          : (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(characters), (character) => {
                return (_openBlock(), _createBlock(CharactersListCard, {
                  key: character.id,
                  id: character.id,
                  name: character.name,
                  image: character.image
                }, null, 8, ["id", "name", "image"]))
              }), 128))
            ]))
    ]),
    _createVNode(CharactersListPagination)
  ], 64))
}
}

})